import { useContext } from "react";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";

export default function IframeWidget({ widgetId, widgetType, height = "700px" }) {
  const agency = useContext(AgencyContext);
  const { myDetails } = agency;
  const agency_id = myDetails ? myDetails?.agency_id : null;
  const agency_cdn = myDetails?.domain?.chatbotDomain;
  const src = generateSrc();
  return (
    <iframe
      title={agency_id ? myDetails?.branding?.agency_name : "Insighto.ai"}
      src={src}
      allow="microphone"
      style={{
        border: "none",
        width: "100%",
        height,
      }}
    />
  );
  function generateSrc() {
    const hostname = agency_id && agency_cdn ? agency_cdn : "cdn.insighto.ai";
    const url = new URL(`https://${hostname}`);
    const pathnamesWidgetTypes = {
      web_call: "web-call-iframe.html",
      html_call: "call-iframe.html",
    };
    const pathname = pathnamesWidgetTypes[widgetType] || "bot-iframe.html";
    url.pathname = `/${pathname}`;
    url.searchParams.append("widgetId", widgetId);
    return url.toString();
  }
}
